export default __webpack_public_path__ + "static/media/王志宇.a0e5a92a.jpg";